var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_967_16661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7354 15.5137C30.1133 17.2056 32.961 18.1096 35.8784 18.0986V12.3115C35.3049 12.3131 34.7329 12.2516 34.1727 12.1282V16.7387C31.2487 16.7439 28.3969 15.8295 26.0201 14.1248V26.027C26.0129 27.9801 25.4778 29.8948 24.4715 31.5681C23.4652 33.2414 22.0252 34.611 20.3042 35.5316C18.5833 36.4521 16.6455 36.8894 14.6963 36.797C12.7472 36.7046 10.8594 36.086 9.23303 35.0068C10.7374 36.5302 12.6595 37.5725 14.7561 38.0018C16.8527 38.4311 19.0294 38.2281 21.0106 37.4183C22.9918 36.6086 24.6884 35.2287 25.8855 33.4533C27.0826 31.6778 27.7265 29.5868 27.7354 27.4449V15.5137ZM29.8459 9.61083C28.6367 8.29899 27.8947 6.62381 27.7354 4.84608V4.09375H26.1165C26.3166 5.22376 26.7521 6.29898 27.3946 7.24949C28.0371 8.20001 28.8723 9.00456 29.8459 9.61083ZM12.9817 30.4253C12.4206 29.6908 12.0767 28.8135 11.9892 27.8931C11.9017 26.9727 12.0742 26.0462 12.4869 25.2191C12.8996 24.3919 13.536 23.6973 14.3237 23.2144C15.1113 22.7314 16.0187 22.4795 16.9424 22.4872C17.4524 22.4871 17.9593 22.5651 18.4457 22.7187V16.7387C17.8772 16.6633 17.3038 16.6311 16.7304 16.6422V21.2912C15.5461 20.9165 14.2644 21.0017 13.1401 21.5299C12.0157 22.058 11.1312 22.9904 10.6624 24.1415C10.1936 25.2926 10.1749 26.5782 10.61 27.7425C11.0451 28.9068 11.9021 29.8646 13.0106 30.4253H12.9817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0193 14.0862C28.3961 15.7909 31.2479 16.7053 34.1719 16.7001V12.0897C32.5059 11.7371 30.9925 10.8701 29.8451 9.61083C28.8715 9.00456 28.0363 8.20001 27.3938 7.24949C26.7513 6.29898 26.3158 5.22376 26.1157 4.09375H21.8563V27.4449C21.8523 28.4785 21.525 29.4849 20.9204 30.3228C20.3158 31.1608 19.4642 31.7881 18.4851 32.1169C17.5061 32.4457 16.4488 32.4593 15.4616 32.1559C14.4744 31.8525 13.6069 31.2473 12.9809 30.4253C11.9888 29.9242 11.1943 29.1033 10.7256 28.0949C10.2569 27.0865 10.1412 25.9495 10.3973 24.8673C10.6535 23.785 11.2664 22.8207 12.1373 22.1299C13.0081 21.4391 14.0861 21.0621 15.1973 21.0597C15.7072 21.0614 16.2139 21.1394 16.7006 21.2912V16.6422C14.5975 16.6927 12.5549 17.3568 10.8235 18.5528C9.09217 19.7489 7.74739 21.4249 6.95428 23.3751C6.16117 25.3254 5.95424 27.4649 6.3589 29.5312C6.76356 31.5975 7.7622 33.5005 9.23222 35.0067C10.8589 36.0937 12.7497 36.7188 14.7032 36.8152C16.6567 36.9116 18.5998 36.4759 20.3255 35.5544C22.0511 34.6329 23.4947 33.2602 24.5025 31.5824C25.5103 29.9046 26.0445 27.9847 26.0482 26.027L26.0193 14.0862Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_967_16661",
    x: 0,
    y: 0,
    width: 40,
    height: 40.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_967_16661"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.2950d15e748d9e7c65b653ef72421ebd.svg";
export { ForwardRef as ReactComponent };